import React, { useState, useEffect } from "react";
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase";
import { Editor } from "@tinymce/tinymce-react"; // ✅ TinyMCE Editor

const AdminPanel = () => {
  // 📰 المقالات
  const [title, setTitle] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [content, setContent] = useState("");
  const [blogs, setBlogs] = useState([]);
  const [editId, setEditId] = useState(null);

  // 🎥 الفيديوهات
  const [videoTitle, setVideoTitle] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [videos, setVideos] = useState([]);
  const [editVideoId, setEditVideoId] = useState(null);

  const [loading, setLoading] = useState(false);

  // جلب المقالات
  const fetchBlogs = async () => {
    const querySnapshot = await getDocs(collection(db, "blogs"));
    const blogsData = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setBlogs(
      blogsData.sort((a, b) => b.createdAt?.seconds - a.createdAt?.seconds)
    );
  };

  // جلب الفيديوهات
  const fetchVideos = async () => {
    const querySnapshot = await getDocs(collection(db, "videos"));
    const videosData = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setVideos(
      videosData.sort((a, b) => b.createdAt?.seconds - a.createdAt?.seconds)
    );
  };

  useEffect(() => {
    fetchBlogs();
    fetchVideos();
  }, []);

  // ✅ حفظ أو تعديل المقال
  const handleBlogSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (editId) {
        await updateDoc(doc(db, "blogs", editId), { title, imageUrl, content });
        alert("✏️ تم تعديل المقال بنجاح!");
        setEditId(null);
      } else {
        await addDoc(collection(db, "blogs"), {
          title,
          imageUrl,
          content,
          createdAt: serverTimestamp(),
        });
        alert("✅ تمت إضافة المقال بنجاح!");
      }
      setTitle("");
      setImageUrl("");
      setContent("");
      fetchBlogs();
    } catch (error) {
      alert("❌ حدث خطأ أثناء حفظ المقال");
      console.error(error);
    }
    setLoading(false);
  };

  // ✅ حذف مقال
  const handleDeleteBlog = async (id) => {
    if (window.confirm("هل أنت متأكد من حذف هذا المقال؟")) {
      await deleteDoc(doc(db, "blogs", id));
      alert("🗑️ تم حذف المقال!");
      fetchBlogs();
    }
  };

  // ✅ تعديل مقال
  const handleEditBlog = (blog) => {
    setTitle(blog.title);
    setImageUrl(blog.imageUrl);
    setContent(blog.content);
    setEditId(blog.id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // 🎬 إضافة أو تعديل فيديو
  const handleVideoSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (editVideoId) {
        await updateDoc(doc(db, "videos", editVideoId), {
          title: videoTitle,
          url: videoUrl,
        });
        alert("✏️ تم تعديل الفيديو بنجاح!");
        setEditVideoId(null);
      } else {
        await addDoc(collection(db, "videos"), {
          title: videoTitle,
          url: videoUrl,
          createdAt: serverTimestamp(),
        });
        alert("🎥 تمت إضافة الفيديو بنجاح!");
      }
      setVideoTitle("");
      setVideoUrl("");
      fetchVideos();
    } catch (error) {
      alert("❌ حدث خطأ أثناء حفظ الفيديو");
      console.error(error);
    }
    setLoading(false);
  };

  // 🎬 حذف فيديو
  const handleDeleteVideo = async (id) => {
    if (window.confirm("هل أنت متأكد من حذف هذا الفيديو؟")) {
      await deleteDoc(doc(db, "videos", id));
      alert("🗑️ تم حذف الفيديو!");
      fetchVideos();
    }
  };

  // 🎬 تعديل فيديو
  const handleEditVideo = (video) => {
    setVideoTitle(video.title);
    setVideoUrl(video.url);
    setEditVideoId(video.id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="admin-container">
      <style>
        {`
          .admin-container {
            min-height: 100vh;
            background-color: #000;
            color: #d4af37;
            display: flex;
            flex-direction: column;
            align-items: center;
            font-family: 'Cairo', sans-serif;
            padding: 50px 20px;
          }
          .admin-form {
            background: #111;
            border: 1px solid #d4af37;
            border-radius: 16px;
            box-shadow: 0 0 15px rgba(212, 175, 55, 0.3);
            padding: 30px;
            width: 100%;
            max-width: 600px;
            margin-bottom: 50px;
          }
          .admin-form h2 {
            text-align: center;
            color: #d4af37;
            margin-bottom: 25px;
            font-size: 26px;
          }
          .admin-form label {
            color: #fff;
            margin-bottom: 8px;
            display: block;
            font-weight: bold;
          }
          .admin-form input {
            width: 100%;
            background: #000;
            border: 1px solid #d4af37;
            border-radius: 8px;
            color: #fff;
            padding: 10px;
            margin-bottom: 20px;
            font-size: 15px;
          }
          .admin-form button {
            width: 100%;
            padding: 12px;
            background: transparent;
            border: 2px solid #d4af37;
            color: #d4af37;
            font-weight: bold;
            font-size: 16px;
            border-radius: 10px;
            cursor: pointer;
            transition: 0.3s;
          }
          .admin-form button:hover {
            background: #d4af37;
            color: #000;
          }
          table {
            width: 100%;
            max-width: 1000px;
            border-collapse: collapse;
            color: #fff;
            background: #111;
            border: 1px solid #d4af37;
            border-radius: 10px;
            overflow: hidden;
            margin-bottom: 60px;
          }
          th, td {
            border: 1px solid #d4af37;
            padding: 12px;
            text-align: center;
          }
          th {
            background: #000;
            color: #d4af37;
          }
          tr:hover {
            background: #222;
          }
          img {
            width: 60px;
            height: 60px;
            border-radius: 6px;
            object-fit: cover;
            border: 1px solid #d4af37;
          }
          .action-btn {
            border: 1px solid #d4af37;
            padding: 6px 12px;
            border-radius: 8px;
            margin: 0 4px;
            cursor: pointer;
            font-weight: bold;
          }
          .edit-btn {
            color: #d4af37;
          }
          .edit-btn:hover {
            background: #d4af37;
            color: #000;
          }
          .delete-btn {
            color: #ff5555;
            border-color: #ff5555;
          }
          .delete-btn:hover {
            background: #ff5555;
            color: #000;
          }
        `}
      </style>

      {/* 📰 قسم المقالات */}
      <form onSubmit={handleBlogSubmit} className="admin-form">
        <h2>{editId ? "✏️ تعديل المقال" : "📝 إضافة مقالة جديدة"}</h2>
        <label>عنوان المقال:</label>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
        <label>رابط الصورة:</label>
        <input
          type="text"
          value={imageUrl}
          onChange={(e) => setImageUrl(e.target.value)}
          placeholder="https://example.com/image.jpg"
          required
        />
        <label>محتوى المقال:</label>
        <Editor
          apiKey="ed5gqe3xen6ohca7sw4s4fozeudblp8882cth23oc8nso2ue"
          value={content}
          onEditorChange={(newValue) => setContent(newValue)}
          init={{
            height: 300,
            menubar: false,
            directionality: "rtl",
            language: "ar",
            skin: "oxide-dark",
            content_css: "dark",
            plugins: ["lists link image preview code fullscreen"],
            toolbar:
              "undo redo | formatselect | bold italic underline | alignleft aligncenter alignright | bullist numlist | code preview",
          }}
        />
        <button type="submit">{editId ? "تحديث المقال" : "حفظ المقال"}</button>
      </form>

      {/* جدول المقالات */}
      <h2>📰 المقالات المضافة</h2>
      <table>
        <thead>
          <tr>
            <th>العنوان</th>
            <th>الصورة</th>
            <th>التحكم</th>
          </tr>
        </thead>
        <tbody>
          {blogs.map((b) => (
            <tr key={b.id}>
              <td>{b.title}</td>
              <td>
                <img src={b.imageUrl} alt={b.title} />
              </td>
              <td>
                <button
                  className="action-btn edit-btn"
                  onClick={() => handleEditBlog(b)}
                >
                  تعديل
                </button>
                <button
                  className="action-btn delete-btn"
                  onClick={() => handleDeleteBlog(b.id)}
                >
                  حذف
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* 🎥 قسم الفيديوهات */}
      <form onSubmit={handleVideoSubmit} className="admin-form">
        <h2>{editVideoId ? "✏️ تعديل الفيديو" : "🎥 إضافة فيديو جديد"}</h2>
        <label>عنوان الفيديو:</label>
        <input
          type="text"
          value={videoTitle}
          onChange={(e) => setVideoTitle(e.target.value)}
          required
        />
        <label>رابط الفيديو (YouTube أو غيره):</label>
        <input
          type="text"
          value={videoUrl}
          onChange={(e) => setVideoUrl(e.target.value)}
          placeholder="https://www.youtube.com/watch?v=..."
          required
        />
        <button type="submit">
          {editVideoId ? "تحديث الفيديو" : "حفظ الفيديو"}
        </button>
      </form>

      {/* جدول الفيديوهات */}
      <h2>📽️ الفيديوهات المضافة</h2>
      <table>
        <thead>
          <tr>
            <th>العنوان</th>
            <th>الرابط</th>
            <th>التحكم</th>
          </tr>
        </thead>
        <tbody>
          {videos.map((v) => (
            <tr key={v.id}>
              <td>{v.title}</td>
              <td>
                <a
                  href={v.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#d4af37" }}
                >
                  عرض الفيديو
                </a>
              </td>
              <td>
                <button
                  className="action-btn edit-btn"
                  onClick={() => handleEditVideo(v)}
                >
                  تعديل
                </button>
                <button
                  className="action-btn delete-btn"
                  onClick={() => handleDeleteVideo(v.id)}
                >
                  حذف
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminPanel;
